import { SerdeDtoClass } from '@zaoblako/shared/modules/serde/classes/serde-dto.class';
import { FinanceDtoKeysEnum } from '@zaoblako/shared/modules/finance/enums/finance-dto-keys.enum';
import { nonEmptyStringSchema } from '@zaoblako/shared/modules/serde/schemas/non-empty-string.schema';

/** Classifier name within balance report structure form */
export interface BalanceReportFormatClassifierFormInterface {
  /** Classifier display name (without income/expense prefix) */
  name: string;
}

export const BalanceReportFormatClassifierFormDto = SerdeDtoClass.create<BalanceReportFormatClassifierFormInterface>(
  FinanceDtoKeysEnum.BALANCE_REPORT_FORMAT_CLASSIFIER_FORM_DTO,
  {
    name: {
      label: 'Название',
      serializer: nonEmptyStringSchema,
    },
  },
);
